module.exports = __webpack_public_path__ + "img/roof.126831d9.svg";